<template>
  <div class="main-header">
    <div class="left-items"></div>
    <div class="right-items">
      <el-dropdown split-button type="primary" @command="onDropDownCommand">
        {{ $store.state.identity.username }}
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">Logout</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainHeader",
  methods: {
    onDropDownCommand(command) {
      switch (command) {
        case "logout": {
          this.$store.commit("logout");
          window.location.href = "/";
          break;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/app-variables";

.main-header {
  background-color: $--app-main-color;
  //box-shadow: 0 -6px 10px 6px $--app-main-color;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
}
</style>
